"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegex = escapeRegex;
// escape regex characters helper function copied from
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions

function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}